import { Tag } from 'antd';
import moment from 'moment';

import { tagColor } from 'src/utils/helper/functions.helper';

const asColor = (color?: string) => {
  if (!color) return 'default';
  return color;
};

const hourTag = (hours: any, record: any, type: string, target?: number) => {
  const value =
    record.hoursInterval.find((item: any) => {
      return Number(item.hour) === Number(hours);
    })?.quantity || 0;

  const hourTarget = type === 'operator' ? record?.hourTarget : target;

  return (
    <Tag
      key={record.id}
      color={tagColor(value, hourTarget, 'hourTarget')}
      className="m-0"
    >
      <b>{value}</b>
    </Tag>
  );
};

const hoursInterval = (type: string, target?: number) => {
  const allHours = [
    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 0,
  ];

  const displayHour: any[] = [];

  allHours.forEach((item: any) => {
    if (moment(item).isSame(moment(), 'day')) {
      if (item <= moment().hours()) {
        displayHour.push({
          key: `${item}:00`,
          title: `${item}:00`,
          dataIndex: item,
          width: 60,
          render: (text: any, record: any) =>
            hourTag(item, record, type, target),
        });
      }
    } else {
      displayHour.push({
        key: `${item}:00`,
        title: `${item}:00`,
        dataIndex: item,
        width: 60,
        render: (text: any, record: any) => hourTag(item, record, type, target),
      });
    }
  });

  return displayHour;
};

export const operatorColumns = [
  {
    title: 'Cód.',
    dataIndex: 'operatorId',
    key: 'operatorId',
    fixed: 'left',
    width: 50,
  },
  {
    title: 'Operação',
    dataIndex: 'operation',
    key: 'operation',
    fixed: 'left',
    width: 100,
    render: (text: any, record: any) =>
      `${record?.operationId} - ${record?.operationName}`,
  },
  {
    title: 'Meta',
    dataIndex: 'hourTarget',
    key: 'hourTarget',
    width: 70,
    fixed: 'left',
    className: 'justify-content-center',
    render: (text: string) => (
      <Tag color="blue" className="m-0">
        <b>{Math.trunc(Number(text))}</b>
      </Tag>
    ),
  },
  ...hoursInterval('operator'),
  {
    title: 'Total',
    key: 'total',
    width: 70,
    fixed: 'right',
    render: (text: any, record: any) => {
      return (
        <Tag
          color={tagColor(record.total, record.hourTarget, 'total')}
          className="m-0"
        >
          <b>{record.total}</b>
        </Tag>
      );
    },
  },
];

export const operationColumns = (target: number) => [
  {
    title: 'Cód.',
    dataIndex: 'operationId',
    key: 'operationId',
    fixed: 'left',
    width: 50,
  },
  {
    title: 'Operação',
    dataIndex: 'operationName',
    key: 'operationName',
    fixed: 'left',
    width: 100,
  },
  ...hoursInterval('operation', target),
  {
    title: 'Total',
    key: 'total',
    width: 70,
    fixed: 'right',
    render: (text: any, record: any) => {
      return (
        <Tag color={tagColor(record.total, target, 'total')} className="m-0">
          <b>{record.total}</b>
        </Tag>
      );
    },
  },
];

export const efficiencyColor = (efficiency: number) => {
  if (!efficiency || efficiency <= 0) return 'default';

  if (efficiency > 100) return 'blue';
  if (efficiency > 80) return 'green';
  if (efficiency > 60) return 'yellow';
  if (efficiency > 40) return 'orange';

  return 'red';
};

const operationGroupHourTag = (hour: number, record: any) => {
  const hourInterval =
    record.hoursInterval?.find((item: any) => Number(item.hour) === Number(hour)) ||
    ({ quantity: 0, color: 'default' } as any);

  const efficiencyHour =
    record.efficiencyPerHourArray?.find((item: any) => Number(item.hour) === Number(hour)) ||
    ({ efficiency: 0, color: 'default' } as any);

  const qty = Number(hourInterval.quantity || 0);
  const qtyColor = asColor(hourInterval.color);
  const eff = Number(efficiencyHour.efficiency || 0);
  const effColor = asColor(efficiencyHour.color) || efficiencyColor(eff);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Tag color={qtyColor} className="m-0" style={{ textAlign: 'center' }}>
        <b>{qty}</b>
      </Tag>
      <Tag color={effColor} className="m-0" style={{ textAlign: 'center' }}>
        <b>{eff.toFixed(2)}%</b>
      </Tag>
    </div>
  );
};

const operationGroupHoursInterval = () => {
  const allHours = [7, 8, 9, 10, 11, 13, 14, 15, 16];

  const displayHour: any[] = [];

  allHours.forEach((item: number) => {
    if (moment(item).isSame(moment(), 'day')) {
      if (item <= moment().hours()) {
        displayHour.push({
          key: `${item}:00`,
          title: `${item}:00`,
          dataIndex: item,
          width: 70,
          align: 'center' as const,
          render: (_text: any, record: any) => operationGroupHourTag(item, record),
        });
      }
    } else {
      displayHour.push({
        key: `${item}:00`,
        title: `${item}:00`,
        dataIndex: item,
        width: 70,
        align: 'center' as const,
        render: (_text: any, record: any) => operationGroupHourTag(item, record),
      });
    }
  });

  return displayHour;
};

export const operationGroupColumns = [
  {
    title: 'Grupo',
    dataIndex: 'operationGroupName',
    key: 'operationGroupName',
    fixed: 'left' as const,
    width: 220,
    render: (_text: any, record: any) =>
      record.operationGroupId === null ? 'SEM GRUPO' : record.operationGroupName || 'SEM GRUPO',
  },
  ...operationGroupHoursInterval(),
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    width: 90,
    fixed: 'right' as const,
    align: 'center' as const,
    render: (text: number, record: any) => (
      <Tag color={asColor(record.color)} className="m-0">
        <b>{Number(text || 0)}</b>
      </Tag>
    ),
  },
  {
    title: 'Eficiência (%)',
    dataIndex: 'efficiency',
    key: 'efficiency',
    width: 130,
    fixed: 'right' as const,
    align: 'center' as const,
    render: (text: number, record: any) => (
      <Tag color={asColor(record.color) || efficiencyColor(Number(text || 0))} className="m-0">
        <b>{Number(text || 0).toFixed(2)}%</b>
      </Tag>
    ),
  },
];

const efficiencyHourTag = (hour: number, record: any) => {
  const hourData =
    record.efficiencyPerHourArray?.find(
      (item: any) => item.hour === hour
    ) || { efficiency: 0 };

  return (
    <Tag
      key={`${record.operatorId}-${hour}`}
      color={efficiencyColor(hourData.efficiency)}
      className="m-0"
    >
      <b>{hourData.efficiency.toFixed(2)}%</b>
    </Tag>
  );
};

const efficiencyHoursInterval = () => {
  const allHours = [
    6, 7, 8, 9, 10, 11,
    12, 13, 14, 15, 16, 
    17, 18, 19, 20, 21, 22, 23,
  ];

  return allHours.map((hour) => ({
    key: `hour-${hour}`,
    title: `${hour}:00`,
    dataIndex: hour.toString(),
    width: 80,
    align: 'center' as const,
    render: (_text: any, record: any) => efficiencyHourTag(hour, record),
  }));
};

export const efficiencyColumns = [
  {
    title: 'Cód.',
    dataIndex: 'operatorId',
    key: 'operatorId',
    fixed: 'left',
    width: 80,
  },
  {
    title: 'Operador',
    dataIndex: 'operator',
    key: 'operator',
    fixed: 'left',
    width: 250,
  },
   ...efficiencyHoursInterval(),
  {
    title: 'Produção Total',
    dataIndex: 'totalProduction',
    key: 'totalProduction',
    width: 130,
    align: 'center' as const,
    render: (text: number) => (
      <Tag color="geekblue" className="m-0">
        <b>{text}</b>
      </Tag>
    ),
  },
  {
    title: 'Eficiência (%)',
    dataIndex: 'efficiency',
    key: 'efficiency',
    width: 130,
    align: 'center' as const,
    render: (text: number, record: any) => (
      <Tag color={record.color} className="m-0">
        <b>{text.toFixed(2)}%</b>
      </Tag>
    ),
  },
];
 